// extracted by mini-css-extract-plugin
export default {"EmployeeList":"EmployeeList_EmployeeList__DpM5s"};